import React, { useEffect, useState } from 'react';
import { AnyDto } from 'src/components/common/common';
import { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { ItemDto } from 'src/dtos/item/itemDto';
import { OrganizationDto } from 'src/dtos/organization/organizationDto';
import { WareHouseDto } from 'src/dtos/warehouse/wareHouseDto';
import { WorkPlaceDto } from 'src/dtos/workplace/workPlaceDto';
import { HrmCodeAttendDto } from 'src/dtos/hrmCodeAttend/hrmCodeAttendDto';
import { HrmWorkShiftDto } from 'src/dtos/hrmWorkShift/hrmWorkShiftDto';

interface DropDownFormContentProps<T extends AnyDto> {
    optionList: T[] | undefined;
	isOpen?: boolean;			setIsOpen?: (isOpen: boolean) => void;
	buttonRef?: React.RefObject<HTMLButtonElement | null>;
	setListPosition?: (listPosition: { top: number; left: number; width: number }) => void;
}



export const DropDownFormContent = <T extends AnyDto>(props: DropDownFormContentProps<T>) => {

	const { 
		optionList,
		isOpen, setIsOpen,
		buttonRef,
		setListPosition,
	} = props;

	// 타입 가드 함수는 any[]를 받고, 특정 DTO 배열인지 검사
	function IsCompanyDtoArray(data: any[] | undefined): data is CompanyDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'compCd' in item && typeof item.compCd === 'string' &&
			'compNm' in item && typeof item.compNm === 'string';
	}

	function IsItemDtoArray(data: any[] | undefined): data is ItemDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'itemCd' in item && typeof item.itemCd === 'string' &&
			'itemNm' in item && typeof item.itemNm === 'string';
	}

	function IsCodeDtoArray(data: any[] | undefined): data is SysCodeDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'majorCd' in item && typeof item.majorCd === 'string' &&
			'minorCd' in item && typeof item.minorCd === 'string' &&
			'codeNm' in item && typeof item.codeNm === 'string';
	}

	/** 근태코드 DTO 목록을 식별한다. @param data 검색 옵션 목록 @returns 근태코드 목록이면 true */
	function IsHrmCodeAttendDtoArray(data: unknown[] | undefined): data is HrmCodeAttendDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'attendCd' in item && typeof item.attendCd === 'string' &&
			'attendNm' in item && typeof item.attendNm === 'string';
	}

	/** 근무조 DTO 목록을 식별한다. @param data 검색 옵션 목록 @returns 근무조 목록이면 true */
	function IsHrmWorkShiftDtoArray(data: unknown[] | undefined): data is HrmWorkShiftDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'shiftCd' in item && typeof item.shiftCd === 'string' &&
			'shiftNm' in item && typeof item.shiftNm === 'string';
	}

	function IsOrganizationDtoArray(data: any[] | undefined): data is OrganizationDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'orgCd' in item && typeof item.orgCd === 'string'
	}

	function IsWareHouseDtoArray(data: any[] | undefined): data is WareHouseDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'warehouseCd' in item && typeof item.warehouseCd === 'string' &&
			'warehouseNm' in item && typeof item.warehouseNm === 'string';
	}

	function IsWorkPlaceDtoArray(data: any[] | undefined): data is WorkPlaceDto[] {
		if (!Array.isArray(data) || data.length === 0) return false;
		const item = data[0];
		return typeof item === 'object' && item !== null &&
			'workplaceCd' in item && typeof item.workplaceCd === 'string' &&
			'workplaceNm' in item && typeof item.workplaceNm === 'string';
	}

    // 드롭다운 목록 위치 계산
	useEffect(() => {
        if (isOpen && buttonRef?.current && setListPosition) {
            const rect = buttonRef.current.getBoundingClientRect();
            setListPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
            });
        }
    }, [isOpen, buttonRef, setListPosition]);

	return {
        // SearchDropDownForm에서 optionList를 전달받아 실행할 수 있는 함수를 반환
		IsCompanyDtoArray,
		IsItemDtoArray,
		IsCodeDtoArray,
		IsHrmCodeAttendDtoArray,
		IsHrmWorkShiftDtoArray,
		IsOrganizationDtoArray,
		IsWareHouseDtoArray,
		IsWorkPlaceDtoArray,
	};
}
